var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.30361 0.113281H1.6752C1.81415 0.180552 1.95865 0.237974 2.09125 0.315089C6.10246 2.6433 10.1129 4.97316 14.1225 7.30465C15.1245 7.88712 16.1265 8.4704 17.1285 9.0545C17.535 9.29241 17.7161 9.66568 17.6454 10.1087C17.5851 10.491 17.3334 10.7108 17.0221 10.8913C12.8871 13.2912 8.75304 15.6929 4.62009 18.0966C3.74115 18.6069 2.86459 19.1204 1.98247 19.625C1.41715 19.9531 0.75021 19.6701 0.586649 19.0433C0.555826 18.9002 0.543278 18.7534 0.54933 18.6069C0.54933 12.8304 0.54933 7.05416 0.54933 1.2782C0.54933 1.19617 0.54933 1.11413 0.554888 1.03209C0.58506 0.630111 0.787524 0.355287 1.13846 0.191212L1.30361 0.113281Z",
    fill: "#3D81FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.29ab8b544f9d126bd3ca6343f592ac52.svg";
export { ForwardRef as ReactComponent };